import Row from '@components/Row';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Clock from '@icons/Clock';
import FavoriteAngularFill from '@icons/favorite/FavoriteAngularFill';
import { useState } from 'react';

import MenuShortcut from './MenuShortcut';
import MyMenus from './MyMenus';
import RecentOrders from './RecentOrders';

function QuickOrder() {
    const [isMyMenu, setIsMyMenu] = useState<boolean>(false);
    return (
        <Container>
            <Wrapper>
                <Text size='3xl' fontWeight='bold'>Quick Order</Text>
            </Wrapper>
            <ShortcutRow spacing={8} justify='flex-end'>
                <MenuShortcut icon={Clock} selected={!isMyMenu}
                    onClick={() => setIsMyMenu(false)} >
                    최근 주문
                </MenuShortcut>
                <MenuShortcut icon={FavoriteAngularFill} selected={isMyMenu}
                    onClick={() => setIsMyMenu(true)}>
                    MY메뉴
                </MenuShortcut>
                {/* <MenuShortcut icon={EditIcon}>편집</MenuShortcut> */}
                {isMyMenu && (
                    <FadedTooltip left={28}
                        visibleKey='myMenu'
                        top={40}
                        align='left'
                        color={colors.gray9}
                        backgroundColor={colors.gray3}
                        right='unset'>
                        내가 좋아하는 메뉴를<br/>
                        한 번에 주문할 수 있어요
                    </FadedTooltip>
                )}
            </ShortcutRow>
            {isMyMenu ? (<MyMenus/>) : (<RecentOrders/>)}
        </Container>
    );
}

const Container = styled.section`
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
`;

const wrapperStyle = css`
    padding: 10px 20px 0;
    position: relative;
`;

const Wrapper = styled.div`
    ${wrapperStyle}
`;

const ShortcutRow = styled(Row)`
    ${wrapperStyle}
`;

const FadedTooltip = styled(Tooltip)`
    opacity: .68;
`;

export default QuickOrder;
